import { useCallback, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Loading from "../../../../app/layout/Loading";
import { useStore } from "../../../../app/stores/store";
import LinkExpired from "./LinkExpired";
import { observer } from "mobx-react-lite";
import { Button, Header, Icon, Segment } from "semantic-ui-react";

const ConfirmEmailPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { userStore } = useStore();
  const { verifyEmail, emailStatus } = userStore;
  const [redirectStatus, setRedirectStatus] = useState("");
  const getEmail = useCallback(() => {
    try {
      const email = searchParams.get("email");
      if (email) return email;
      else return "";
    } catch (error) {
      return "";
    }
  }, [searchParams]);

  useEffect(() => {
    setRedirectStatus("");
    verifyEmail(getEmail())
      .then((data) => {
        if (data === "success") {
          //   console.log(data);
          setRedirectStatus("success");
        } else {
          // console.log(data);
          setRedirectStatus("error");
        }
      })
      .catch((error) =>
        error
          ? (console.log(error), setRedirectStatus("error"))
          : setRedirectStatus("error")
      );
  }, [getEmail, verifyEmail]);
  if (emailStatus === "loading") return <Loading />;
  if (redirectStatus === "error") return <LinkExpired />;
  return (
    <>
      <Segment
        style={{ marginTop: 200, cursor: "unset", opacity: "unset" }}
        placeholder
      >
        <Header icon>
          <Icon name="check" />
          Email Verified successfully
        </Header>
        <Segment.Inline>
          <Button onClick={() => navigate("/login")} primary>
            Go to login Page
          </Button>
        </Segment.Inline>
      </Segment>
    </>
  );
};

export default observer(ConfirmEmailPage);
